// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#chapter-markers[data-v-f10d212a]{width:100%}#chapter-markers .v-list__tile .v-list__tile__title[data-v-f10d212a]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
